
export default {
    props: {
        placeholder: {
            type: String,
            default: 'Filter Keyword',
        },
    },
}
